import React, {Component} from 'react';
import {Link} from 'react-router';

import Footer from 'js/components/footer';

const logoGroups = [
    [
        require('images/logos/samsung.png'),
        require('images/logos/loreal.png'),
        require('images/logos/ben_and_jerrys.png'),
        require('images/logos/brand-logo-coca-cola.png'),
    ],
    [
        require('images/logos/red_bull.png'),
        require('images/logos/pottery_barn.png'),
        require('images/logos/audi.png'),
        require('images/logos/victorias_secret.png')
    ]
];

export default class ContentCreator extends Component {
    render() {
        return (
            <div id="content-creator">
                <div id="get-your-brand-involved-mobile" className="hide@sm">
                    <div>
                        Want to get your&nbsp;
                        <strong>brand</strong>
                        &nbsp;involved?
                    </div>
                    <Link className="btn" to="/">
                        Get Started
                    </Link>
                </div>
                <header>
                    <div id="sn-logo" className="hide show@sm">
                        <Link to="/">

                        </Link>
                    </div>
                    <div id="sn-logo-mobile" className="hide@sm">
                        <Link to="/">

                        </Link>
                    </div>
                    <div className="hide show@sm">
                        <Link className="active" to="/content_creator">CONTENT CREATORS</Link>
                        <Link to="/faq">FAQ</Link>
                    </div>

                    <Link to="/" className="hide show@sm brand-involved-link-nav" />
                    <div id="get-your-brand-involved" className="hide show@sm">
                        <div>
                            Want to get your&nbsp;
                            <strong>brand</strong>
                            &nbsp;involved?
                        </div>
                    </div>

                </header>
                <main className="container">
                    <div className="row">
                        <section id="get-paid-to-create" className="gr-6@sm push-6@sm">
                            <div className="section-content">
                                <div className="header-image"></div>
                                <h1>Get your content featured by top brands</h1>
                                <p>Become a Social Native content creator in 4 easy steps:</p>
                                <ol>
                                    <li>Verify your social handle</li>
                                    <li>Create awesome content within the campaign guidelines</li>
                                    <li>Post to your social following</li>
                                    <li>Potentially get paid, featured by the brand, or receive free product!</li>
                                </ol>
                                <a className="btn big"
                                   href="https://socialnative.typeform.com/to/W1E3Qd">Get Started</a>
                                <div id="faq-link">
                                    <Link to="/faq">Or find out more on our
                                        &nbsp;<strong>FAQ</strong>&nbsp;
                                        page
                                    </Link>
                                </div>
                            </div>
                        </section>
                        <div id="get-paid-to-create-iphone" className="gr-6@sm pull-6@sm">
                            <div></div>
                        </div>
                    </div>
                </main>
                <Footer showFaq>
                    <section id="brands">
                        <div className="brands-header no-border">Work with brands like</div>
                        {logoGroups.map((lg, i) => (
                            <div className="brand-logos gr-6@sm" key={i}>
                                {lg.map((l, j) => (
                                    <div className="brand-logo" key={j}
                                         style={{backgroundImage: `url(${l})`}}>

                                    </div>
                                ))}
                            </div>
                        ))}
                    </section>
                </Footer>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./web/js/pages/content_creator.js